import { createFileRoute } from '@tanstack/react-router';
import { AppBundle } from '@/utils/app-bundles';
import { IntegrationsAllRouteView } from '@/pages/workspaces/journeys/integrations/routing';
import { LastWorkspaceResolver } from './-components';

function IntegrationsAllRoute() {
  // Resolve the `/workspaces/last` sentinel to a real id. The resolver is non-blocking, so the
  // view derives the id from the pathname and holds on a loader until the rewrite lands.
  return (
    <LastWorkspaceResolver appBundle={AppBundle.Journeys}>
      <IntegrationsAllRouteView />
    </LastWorkspaceResolver>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/integrations/all')({
  component: IntegrationsAllRoute,
});
